import { Component } from "react";

interface Props {
  errorChild?: React.ReactNode;
  children?: React.ReactNode;
}

export class ErrorBoundary extends Component<Props, { hasError: boolean }> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return this.props.errorChild || null;
    } else {
      return this.props.children;
    }
  }
}
